<template>
  <g class="DotPath">
    <datalas-dot
      v-for="(dot, index) in dots"
      :key="index"
      v-bind="dot"
      :fill="dot.fill"
      :stroke-width="strokeWidth"
      :showOnHover="showOnHover"
      @datum:mouseover="$emit('datum:mouseover', $event)"
      @datum:mouseout="$emit('datum:mouseout', $event)"
      @datum:click="$emit('datum:click', $event)"
    />
  </g>
</template>

<script>
import DatalasDot from './dot.vue';

export default {
  name: 'DatalasDots',
  components: {
    DatalasDot,
  },

  props: {
    fill: {
      type: String,
    },
    data: {
      type: Array,
      default: () => [],
    },
    xAccessor: {
      type: Function,
    },
    yAccessor: {
      type: Function,
    },
    xScale: {
      type: Function,
    },
    yScale: {
      type: Function,
    },
    strokeWidth: {
      type: Number,
    },
    bandwidth: {
      type: Number,
      default: 0,
    },
    showOnHover: Boolean,
  },

  computed: {
    dots() {
      return this.data.map((item) => ({
        x: this.xScale(this.xAccessor(item)),
        y: this.yScale(this.yAccessor(item)),
        fill: this.fill,
        datum: item.datum,
      }));
    },
  },
};
</script>
